export const createObserverCallback = (onEnter, onLeave) => entry => {
  if (entry.isIntersecting) {
    onEnter(entry.target)
    entry.target.dataset.isIntersecting = ''
  } else {
    onLeave(entry.target)
    delete entry.target.dataset.isIntersecting
  }
}
